export type SearchProduct = {
  objectID: string;
  productId?: string | null;
  name?: string | null;
  slug?: string | null;
  imageUrl?: string | null;
  itemType: string;
  itemDetails?: {
    contributorByLine?: string | null;
    binding?: string | null;
  } | null;
  availableBindings?: Array<{ binding: string }> | null;
  formats?: string[];
};

export const PRODUCT_TYPES = [
  "book",
  "product-bundle",
  "subscription",
  "digital-service",
];

export const PRODUCT_ATTRIBUTES = [
  "name",
  "slug",
  "imageUrl",
  "itemType",
  "productId",
  "objectID",
  "itemDetails.contributorByLine",
  "itemDetails.binding",
  "availableBindings",
];

export const MAX_PRODUCTS = 8;

export function toSearchProduct(document: SearchProduct): SearchProduct {
  const {
    objectID,
    productId,
    name,
    slug,
    imageUrl,
    itemType,
    itemDetails,
    availableBindings,
  } = document;
  return {
    objectID,
    productId,
    name,
    slug,
    imageUrl,
    itemType,
    itemDetails: itemDetails
      ? {
          contributorByLine: itemDetails.contributorByLine,
          binding: itemDetails.binding,
        }
      : null,
    availableBindings: availableBindings?.map(({ binding }) => ({ binding })),
  };
}

function getWorkKey(product: SearchProduct) {
  if (product.itemType !== "book" || !product.name)
    return product.productId ?? product.objectID;
  return `${product.name}|${product.itemDetails?.contributorByLine ?? ""}`.toLowerCase();
}

function getFormats(product: SearchProduct) {
  if (product.itemType !== "book") return [];
  const bindings = (product.availableBindings ?? []).map(
    ({ binding }) => binding,
  );
  const binding = product.itemDetails?.binding;
  return binding ? [...bindings, binding] : bindings;
}

export function groupVariants(products: SearchProduct[]) {
  const works = new Map<string, SearchProduct>();
  for (const product of products) {
    const key = getWorkKey(product);
    const work = works.get(key) ?? { ...product, formats: [] };
    for (const format of getFormats(product))
      if (
        !work.formats?.some(
          (existing) => existing.toLowerCase() === format.toLowerCase(),
        )
      )
        work.formats?.push(format);
    works.set(key, work);
  }
  return [...works.values()].slice(0, MAX_PRODUCTS);
}
